module.exports = __webpack_public_path__ + "static/media/14-30.6c80583a.svg";